import { uniqBy } from "lodash-es";

import { PillVariants } from "src/base-components/Pill";
import { Option } from "src/base-components/Select";
import { CaseStatusPill } from "src/cases/common/CaseStatusPill";
import {
  buildBackendStatusKey,
  buildStatusLabel,
} from "src/cases/templates/utils";
import { EnumValue } from "src/clients/case-management";

export const STATUS_FIELD_KEY = "properties.status+enum";

type StatusPair = {
  status: string;
  subStatus?: string;
  statusLabel: string;
  subStatusLabel?: string;
  variant: PillVariants | undefined;
};

const toPairOption = ({
  status,
  subStatus,
  statusLabel,
  subStatusLabel,
  variant,
}: StatusPair): Option => ({
  key: buildBackendStatusKey({ status, subStatus }),
  value: (
    <CaseStatusPill
      status={statusLabel}
      subStatus={subStatusLabel}
      variant={variant}
    />
  ),
  displayValue: buildStatusLabel({
    status: statusLabel,
    subStatus: subStatusLabel,
  }),
  pillVariant: variant,
});

export const buildStatusPairOptions = (values: EnumValue[]): Option[] => {
  const options = values.flatMap((value) => {
    const statusLabel = value.display_name ?? value.value;
    const variant = (value.color ?? undefined) as PillVariants | undefined;

    if (!value.sub_values?.length) {
      return [toPairOption({ status: value.value, statusLabel, variant })];
    }

    return value.sub_values.map((sub) =>
      toPairOption({
        status: value.value,
        subStatus: sub.value,
        statusLabel,
        subStatusLabel: sub.display_name ?? sub.value,
        variant,
      }),
    );
  });

  return uniqBy(options, (option) => option.key);
};
